import { useTranslation } from "react-i18next";
import { useRemoveCouponMutation } from "../api/cartApi";
import { useMutationWithFeedback } from "../../../../common/hooks/hooks";

/**
 * A custom hook to encapsulate the logic for removing a coupon from the cart.
 */
export const useRemoveCoupon = () => {
  const { t } = useTranslation();
  const [removeCouponMutation, mutationResult] = useRemoveCouponMutation();

  const { trigger, isLoading: isRemoving } = useMutationWithFeedback({
    mutation: [removeCouponMutation, mutationResult],
    loadingMessage: t(
      "feedback.cart.coupon.removeLoading",
      "Removing coupon..."
    ),
    successMessage: t(
      "feedback.cart.coupon.removeSuccess",
      "Coupon removed successfully!"
    ),
    errorMessages: {
      default: t(
        "feedback.cart.coupon.removeError",
        "Failed to remove coupon. Please try again."
      ),
    },
    successToastType: "info",
  });

  const handleRemoveCoupon = trigger;

  return { handleRemoveCoupon, isRemoving };
};
